import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import user_placeholder from "../../assets/images/user-placeholder.jpg";
import PageTitle from "../../components/pageTitle/PageTitle.vue";
import providerApiService from "../../services/api/ProviderApiService";
import FetchError from "./../../services/api/FetchError";
import AddEmployee from "./AddEmployee.vue";
import EmployeeAbilities from "./EmployeeAbilities.vue";
export default {
  data: function data() {
    return {
      employees: [],
      showUpdateButton: false,
      showCreateEmployeePopup: false,
      selectedEmployee: null,
      loading: true,
      FetchError: FetchError,
      placeholder: user_placeholder
    };
  },
  components: {
    AddEmployee: AddEmployee,
    PageTitle: PageTitle,
    EmployeeAbilities: EmployeeAbilities
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider"
  }),
  mounted: function mounted() {
    this.fetchEmployees();
  },
  methods: {
    fetchEmployees: function fetchEmployees() {
      var _this = this;

      this.loading = true;
      providerApiService.getEmployees(this.currentProvider.id).then(function (res) {
        _this.employees = res.data;
        _this.loading = false;
        res.data.forEach(function (element) {
          var _this$selectedEmploye;

          if (element.id === ((_this$selectedEmploye = _this.selectedEmployee) === null || _this$selectedEmploye === void 0 ? void 0 : _this$selectedEmploye.id)) {
            _this.selectedEmployee = element;
          }
        });
      }).catch(function (err) {
        return _this.employees = err;
      });
    },
    onClickEmployee: function onClickEmployee(employee) {
      this.selectedEmployee = employee;
    },
    employeeCreated: function employeeCreated(user) {
      this.fetchEmployees();
      this.showCreateEmployeePopup = false;
      this.selectedEmployee = user;
    },
    employeeDeleted: function employeeDeleted() {
      this.fetchEmployees();
      this.selectedEmployee = null;
    }
  }
};